import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];
export const getState = (state) => state;

// PROPOSAL DETAILS
export const getProposalDetails = createSelector(
    getModel,
    (model) => model.proposalDetails,
);

export const getProposalDetailsData = createSelector(
    getProposalDetails,
    (value) => value.data,
);

export const getIsFetchingProposalDetails = createSelector(
    getProposalDetails,
    (value) => value.isFetching,
);

export const getProposalDetailsErrors = createSelector(
    getProposalDetails,
    (value) => value.errors,
);
// SEGMENTS
export const getSegmentsExtraData = createSelector(
    getProposalDetailsData,
    (value) => value.segments,
);

// SYSTEMS
export const getSystems = createSelector(
    getProposalDetailsData,
    (value) => value.systems,
);

// ATTACHMENTS
export const getAttachments = createSelector(
    getProposalDetailsData,
    (value) => value.attachments,
);

// BOMS
export const getBoms = createSelector(
    getProposalDetailsData,
    (value) => value.boms,
);

// DATASHEETS
export const getDatasheets = createSelector(
    getProposalDetailsData,
    (value) => value.datasheets,
);

// PROPOSAL CONTENT
export const getProposalContent = createSelector(
    getModel,
    (model) => model.proposalContent,
);

export const getProposalContentData = createSelector(
    getProposalContent,
    (value) => value.data,
);

export const getIsFetchingProposalContent = createSelector(
    getProposalContent,
    (value) => value.isFetching,
);

export const getProposalContentErrors = createSelector(
    getProposalContent,
    (value) => value.errors,
);

// SELECTED DOCUMENT
export const getSelectedDocument = createSelector(
    getModel,
    (model) => model.selectedDocument,
);

// UPDATE CUSTOM TEMPLATE
export const getUpdateCustomTemplate = createSelector(
    getModel,
    (model) => model.updateCustomTemplate,
);

export const getIsUpdatingCustomTemplate = createSelector(
    getUpdateCustomTemplate,
    (value) => value.isUpdating,
);

export const getUpdateCustomTemplateType = createSelector(
    getUpdateCustomTemplate,
    (value) => value.type,
);

// INITIALIZING
export const getIsInitializing = createSelector(
    getModel,
    (model) => model.initializing,
);

// DOWNLOADING
export const getIsDownloading = createSelector(
    getModel,
    (model) => model.isDownloading,
);

/** PV LAYOUT */
export const getPvLayout = createSelector(getModel, (model) => model.pvLayout);

export const getIsFetchingPvLayout = createSelector(
    getPvLayout,
    (value) => value.isFetching,
);

export const getPvLayoutData = createSelector(
    getPvLayout,
    (value) => value.data,
);

export const getPvLayoutErrors = createSelector(
    getPvLayout,
    (value) => value.errors,
);
